/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { NetworkStatus } from '@apollo/client';
import { useCallback } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import I18n from 'I18n';
import { ASYNC_BULK_GET_QUIZ_ME_QUERY } from '../../../../__generated__/chirp/com/hubspot/academy/gen/ai/skills/rpc/QuizMeRpc.dfc.new';
import { formatSecondsToTimestamp } from './contentUtils.migrated';
import { DIFFICULTY_LEVELS } from '../interactiveEducationConstants.migrated';
import { queryDataFromCache, updateCache } from '../../../utils/DataFetchingClientCache.new';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const QuizMeDefaultState = {
  LESSON: {},
  SHORT_FORM_CONTENT: {},
  TRACK: {}
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useQuizMeSessionConfig = create(set => Object.assign({}, QuizMeDefaultState, {
  deleteQuizState: ({
    contentType,
    contentId
  }) => {
    set(state => {
      const filteredState = Object.assign({}, state[contentType]);
      delete filteredState[contentId];
      return {
        [contentType]: filteredState
      };
    });
  },
  incrementQuestionWithAnswer: ({
    contentType,
    contentId,
    correct
  }) => {
    set(state => {
      const newState = Object.assign({}, state[contentType][contentId], {
        questionIndex: state[contentType][contentId].questionIndex + 1,
        correctAnswers: state[contentType][contentId].correctAnswers + (correct ? 1 : 0)
      });
      return {
        [contentType]: Object.assign({}, state[contentType], {
          [contentId]: newState
        })
      };
    });
  },
  initialiseQuiz: ({
    contentType,
    contentId
  }) => {
    set(state => ({
      [contentType]: Object.assign({}, state[contentType], {
        [contentId]: Object.assign({}, state[contentType][contentId], {
          questionIndex: 0,
          correctAnswers: 0
        })
      })
    }));
  },
  setQuizMeStatus: ({
    contentType,
    contentId,
    quizMeStatus
  }) => {
    set(state => ({
      [contentType]: Object.assign({}, state[contentType], {
        [contentId]: Object.assign({}, state[contentType][contentId], {
          quizMeStatus
        })
      })
    }));
  },
  setQuizMeTasks: ({
    contentType,
    videoContentId,
    tasks
  }) => {
    set(state => ({
      [contentType]: Object.assign({}, state[contentType], {
        [videoContentId]: Object.assign({}, state[contentType][videoContentId], {
          tasks
        })
      })
    }));
  },
  resetQuiz: ({
    contentType,
    videoContentId
  }) => {
    set(state => ({
      [contentType]: Object.assign({}, state[contentType], {
        [videoContentId]: Object.assign({}, state[contentType][videoContentId], {
          questionIndex: 0,
          correctAnswers: 0
        })
      })
    }));
  },
  setClickTimestamp: ({
    contentType,
    contentId,
    timestamp
  }) => {
    set(state => ({
      [contentType]: Object.assign({}, state[contentType], {
        [contentId]: Object.assign({}, state[contentType][contentId], {
          clickTimestamp: timestamp
        })
      })
    }));
  },
  setRenderedTimestamp: ({
    contentType,
    contentId,
    timestamp
  }) => {
    set(state => {
      var _state$contentType$co;
      if (((_state$contentType$co = state[contentType][contentId]) === null || _state$contentType$co === void 0 ? void 0 : _state$contentType$co.renderedTimestamp) !== undefined) {
        return state;
      }
      return {
        [contentType]: Object.assign({}, state[contentType], {
          [contentId]: Object.assign({}, state[contentType][contentId], {
            renderedTimestamp: timestamp
          })
        })
      };
    });
  },
  setDifficultyTasks: ({
    contentType,
    contentId,
    difficultyTasks
  }) => {
    set(state => {
      var _state$contentType$co2;
      return {
        [contentType]: Object.assign({}, state[contentType], {
          [contentId]: Object.assign({}, state[contentType][contentId], {
            difficultyTasks: Object.assign({}, (_state$contentType$co2 = state[contentType][contentId]) === null || _state$contentType$co2 === void 0 ? void 0 : _state$contentType$co2.difficultyTasks, difficultyTasks)
          })
        })
      };
    });
  }
}));

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useQuizMeSession = () => {
  const {
    LESSON,
    SHORT_FORM_CONTENT,
    TRACK,
    deleteQuizState,
    incrementQuestionWithAnswer,
    initialiseQuiz,
    resetQuiz,
    setQuizMeTasks,
    setQuizMeStatus,
    setClickTimestamp,
    setRenderedTimestamp,
    setDifficultyTasks
  } = useQuizMeSessionConfig();
  const getQuizState = useCallback((id, contentType) => {
    switch (contentType) {
      case 'LESSON':
        return LESSON[id];
      case 'SHORT_FORM_CONTENT':
        return SHORT_FORM_CONTENT[id];
      case 'TRACK':
        return TRACK[id];
      default:
        return undefined;
    }
  }, [LESSON, SHORT_FORM_CONTENT, TRACK]);
  const setQuizMeClickTimestamp = useCallback(({
    contentType,
    contentId
  }) => setClickTimestamp({
    contentType,
    contentId,
    timestamp: performance.now()
  }), [setClickTimestamp]);
  const getQuizMeRenderedTimestamp = useCallback(({
    contentType,
    contentId
  }) => {
    var _getQuizState;
    const existing = (_getQuizState = getQuizState(contentId, contentType)) === null || _getQuizState === void 0 ? void 0 : _getQuizState.renderedTimestamp;
    if (existing !== undefined) {
      return existing;
    }
    const timestamp = performance.now();
    setRenderedTimestamp({
      contentType,
      contentId,
      timestamp
    });
    return timestamp;
  }, [getQuizState, setRenderedTimestamp]);
  return {
    deleteQuizState,
    getQuizMeRenderedTimestamp,
    getQuizState,
    incrementQuestionWithAnswer,
    initialiseQuiz,
    resetQuiz,
    setDifficultyTasks,
    setQuizMeClickTimestamp,
    setQuizMeStatus,
    setQuizMeTasks
  };
};
const flattenQuizQuestionsWithCorrelation = ({
  lessonContentId,
  quizTasks
}) => {
  if (quizTasks) {
    return quizTasks.tasks.flatMap(quizMeTaskItem => {
      var _quizMeTaskItem$quizR;
      return ((_quizMeTaskItem$quizR = quizMeTaskItem.quizResponse) === null || _quizMeTaskItem$quizR === void 0 || (_quizMeTaskItem$quizR = _quizMeTaskItem$quizR.quiz) === null || _quizMeTaskItem$quizR === void 0 ? void 0 : _quizMeTaskItem$quizR.questions.map(question => {
        var _quizMeTaskItem$quizR2;
        return Object.assign({}, question, {
          correlationId: (_quizMeTaskItem$quizR2 = quizMeTaskItem.quizResponse) === null || _quizMeTaskItem$quizR2 === void 0 ? void 0 : _quizMeTaskItem$quizR2.correlationId,
          contentId: lessonContentId,
          timestampLabel: question.timestampSeconds !== undefined ? I18n.text('learningCenter.interactiveEducation.quiz.rewatchAt', {
            timestamp: formatSecondsToTimestamp(question.timestampSeconds)
          }) : undefined
        });
      })) || [];
    });
  }
  return [];
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useQuizMeHelpers = () => {
  const {
    getQuizState
  } = useQuizMeSession();
  const formatAsyncQuizMeQuestions = useCallback(({
    lessonContentId,
    contentType,
    initialQuizTasks,
    primaryContentId
  }) => {
    var _quizQuestions$questi;
    const quizSession = getQuizState(lessonContentId !== null && lessonContentId !== void 0 ? lessonContentId : primaryContentId, contentType);
    const quizQuestions = flattenQuizQuestionsWithCorrelation({
      lessonContentId,
      quizTasks: initialQuizTasks
    });
    const questionIndex = quizSession === null || quizSession === void 0 ? void 0 : quizSession.questionIndex;
    const currentCorrelationId = questionIndex !== undefined ? (_quizQuestions$questi = quizQuestions[questionIndex]) === null || _quizQuestions$questi === void 0 ? void 0 : _quizQuestions$questi.correlationId : undefined;
    return {
      currentCorrelationId,
      quizQuestions
    };
  }, [getQuizState]);
  return {
    formatAsyncQuizMeQuestions
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const checkQuizMePollingStatus = (asyncQuizMe, hasError) => {
  if (!asyncQuizMe) return {
    quizReady: false,
    pollingLoading: true,
    retryGeneration: false
  };
  const {
    quizReady,
    pollingLoading,
    retryGeneration
  } = asyncQuizMe.tasks.reduce((prev, current) => {
    // Add 'NOT_FOUND' to the list of failed statuses, when BE has a fix more info: https://git.hubteam.com/HubSpot/LearningCenterUI/issues/9715
    if (hasError) {
      prev.retryGeneration = true;
    }
    if (current.status !== 'COMPLETED' && current.status !== 'FAILED') {
      prev.quizReady = false;
    }
    return prev;
  }, {
    quizReady: true,
    pollingLoading: false,
    retryGeneration: false
  });
  return {
    quizReady,
    pollingLoading,
    retryGeneration
  };
};
export const computeQuizMePollStatus = ({
  networkStatus,
  queryLoading,
  pollData,
  pollError
}) => {
  const isPolling = networkStatus === NetworkStatus.poll || queryLoading;
  const {
    quizReady,
    retryGeneration
  } = checkQuizMePollingStatus(pollData, !!pollError);
  return {
    isPolling,
    quizReady,
    retryGeneration
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const collectTaskIdsFromState = state => {
  if (state !== null && state !== void 0 && state.difficultyTasks) {
    const ids = [];
    DIFFICULTY_LEVELS.forEach(level => {
      const taskId = state.difficultyTasks[level];
      if (taskId) ids.push(taskId);
    });
    if (ids.length > 0) return ids;
  }
  if (state !== null && state !== void 0 && state.tasks) return [state.tasks];
  return [];
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const PRE_ASSESSMENT_DIFFICULTY = 'INTERMEDIATE';

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const buildLessonDifficultyTaskIds = (contentIds, getState) => DIFFICULTY_LEVELS.flatMap(level => contentIds.flatMap(id => {
  var _getState;
  const taskId = (_getState = getState(id)) === null || _getState === void 0 || (_getState = _getState.difficultyTasks) === null || _getState === void 0 ? void 0 : _getState[level];
  return taskId ? [taskId] : [];
}));

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const selectPollTaskByTaskId = (pollTasks, taskId) => taskId ? pollTasks === null || pollTasks === void 0 ? void 0 : pollTasks.find(task => task.taskId === taskId) : undefined;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const normalizeDifficulty = value => DIFFICULTY_LEVELS.find(level => level === value);

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const selectPollTasksByTaskIds = (pollTasks, selectedTaskIds) => {
  const tasksByTaskId = new Map();
  pollTasks.forEach(task => {
    tasksByTaskId.set(task.taskId, task);
  });
  return selectedTaskIds.map(taskId => tasksByTaskId.get(taskId)).filter(task => task !== undefined);
};
const DIFFICULTY_PREFERENCES_STORAGE_KEY = 'quiz-me-difficulty-preferences';

// Keyed by content type + primary content id so difficulty is remembered per lesson and per track.
const buildDifficultyPreferenceKey = (contentType, primaryContentId) => `${contentType}:${primaryContentId}`;
const useDifficultyPreferencesStore = create()(persist(set => ({
  preferences: {},
  setPreference: (key, difficulty) => set(state => ({
    preferences: Object.assign({}, state.preferences, {
      [key]: difficulty
    })
  })),
  clearPreferences: () => set({
    preferences: {}
  })
}), {
  name: DIFFICULTY_PREFERENCES_STORAGE_KEY,
  partialize: state => ({
    preferences: state.preferences
  })
}));

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useDifficultyPreference = (contentType, primaryContentId) => {
  const key = buildDifficultyPreferenceKey(contentType, primaryContentId);
  return useDifficultyPreferencesStore(state => state.preferences[key]);
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const persistDifficulty = (contentType, primaryContentId, difficulty) => useDifficultyPreferencesStore.getState().setPreference(buildDifficultyPreferenceKey(contentType, primaryContentId), difficulty);

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const clearPersistedDifficulty = () => useDifficultyPreferencesStore.getState().clearPreferences();

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/utils/quizMeUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const spliceQuizMeCache = ({
  oldTaskIds,
  oldTaskId,
  newTaskId,
  newTaskData
}) => {
  const existingData = queryDataFromCache(ASYNC_BULK_GET_QUIZ_ME_QUERY, {
    taskIds: oldTaskIds
  });
  if (!existingData) return false;
  const targetIndex = existingData.tasks.findIndex(task => task.taskId === oldTaskId);
  if (targetIndex === -1) return false;
  const updatedTasks = [...existingData.tasks];
  updatedTasks[targetIndex] = newTaskData;

  // The query is cached by its taskIds arg, so re-key it with the swapped ids.
  const newTaskIds = oldTaskIds.map(id => id === oldTaskId ? newTaskId : id);
  updateCache(ASYNC_BULK_GET_QUIZ_ME_QUERY, draft => {
    draft.tasks = updatedTasks;
  }, {
    taskIds: newTaskIds
  });
  return true;
};